

export const ReportTypes = [
    'Availability',
    'Scraps',
    'Confirmed scrap ratio',
    'Potential scraps time spent',
    'Measurement counts',
    'Measurement delays',
    'Shift delays',
    'Setups',
] as const;
export type ReportType = typeof ReportTypes[number];

export const ResolutionOptions = [
    'Days',
    'Weeks',
    'Months',
] as const;
export type Resolution = typeof ResolutionOptions[number];

export const MainValueOptions = [
    'Percentage',
    'Sum',
] as const;
export type MainValue = typeof MainValueOptions[number];

export const ShiftsDisplayOptions = [
    'Joined',
    'Separated',
] as const;
export type ShiftsDisplay = typeof ShiftsDisplayOptions[number];

export const ShiftOptions = [
    { key: 'morning', label: 'Morning' },
    { key: 'evening', label: 'Evening' },
    { key: 'night', label: 'Night' },
] as const;
export type ShiftOption = (typeof ShiftOptions)[number]['key'];


export interface PeriodOption {
    start: Date;
    end: Date; // Exclusive end: the start of the next period, not the last included instant.
    periodLabel: string;
    startLabel: string;
    endLabel: string;
}

export interface ReportSettings {
    reportType: ReportType;
    resolution: Resolution;
    mainValue: MainValue;
    shiftsDisplay: ShiftsDisplay;
    visibleShifts: ShiftOption[];
    showOperators: boolean;
    weekends: boolean;
    workdays: boolean;
    first: PeriodOption;
    last: PeriodOption;
    periodsInRange: PeriodOption[];
    availabilityTargetValue?: string;
}
